import { render, staticRenderFns } from "./PacBio.vue?vue&type=template&id=35509bc7&scoped=true"
import script from "./PacBio.vue?vue&type=script&lang=ts"
export * from "./PacBio.vue?vue&type=script&lang=ts"
import style0 from "./PacBio.vue?vue&type=style&index=0&id=35509bc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35509bc7",
  null
  
)

export default component.exports